export default "__VITE_ASSET__CO1P1E1B__"